import React from 'react';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';
import { useFormikContext } from 'formik';
import { useOrderedNodes } from 'src/lib/react-register-nodes';

import { useUpdateEffect } from './useUpdateEffect';

export function useFormikAutoFocus(withAutoFocus) {
  const { submitCount, isValidating } = useFormikContext();
  const prevSubmitCountRef = React.useRef(submitCount);
  const ordered = useOrderedNodes();

  useUpdateEffect(() => {
    if (!withAutoFocus) return null;
    if (!isValidating && prevSubmitCountRef.current !== submitCount && ordered.length > 0) {
      prevSubmitCountRef.current = submitCount;
      const firstNode = ordered[0];
      smoothScrollIntoView(firstNode, {
        scrollMode: 'if-needed',
        block: 'center',
        inline: 'start'
      }).then(() => {
        if ('tabIndex' in firstNode && firstNode['tabIndex'] > -1) {
          firstNode.focus();
        } else {
          firstNode.querySelectorAll('input, textarea')[0].focus();
        }
      });
    }
  }, [ordered, isValidating, submitCount]);
}
